/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { NotificationApiMessageCenterApiService } from './services/notification-api-message-center-api.service';
import { CorsApiService } from './services/cors-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    NotificationApiMessageCenterApiService,
    CorsApiService,
    ApiConfiguration
  ],
})
export class NotificationsDataAccessApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<NotificationsDataAccessApiModule> {
    return {
      ngModule: NotificationsDataAccessApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: NotificationsDataAccessApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('NotificationsDataAccessApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
